export const Locale = {
  EN: 'en',
};

export const DEFAULT_LOCALE = Locale.EN;
